import {
  ComplexesUpdatePurchaseParams,
  ComplexesUpdatePurchaseSuccess,
} from 'app/dataTypes/org/complexes/updatePurchases'

import type { Request } from '../../../../index'

type ParamsApi = {
  date: string
}

type UrlParams = {
  orgId: string
  orgComplexId: string
}

export const convertParams = (params: ComplexesUpdatePurchaseParams): [ParamsApi, UrlParams] => {
  const { date, orgId, orgComplexId } = params
  return [{ date: date.getStringFormatted('YYYY-MM-DD') }, { orgId, orgComplexId }]
}

type ResultApi = 'success'

export const convertResult = (result: ResultApi): ComplexesUpdatePurchaseSuccess => !!result

export const POST_ORSG_COMPLEXES_UPDATE_PURCHASE: Request<
  ComplexesUpdatePurchaseParams,
  ComplexesUpdatePurchaseSuccess,
  UrlParams
> = ['food/schools/{orgId}/complexes/{orgComplexId}/update_purchases', 'post', ['data', 'result']]
